module.exports = __webpack_public_path__ + "img/0Q3A9771_L_Black_MockedUp.15128ad9.jpg";